"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initModuleRegistry = void 0;
const effector_1 = require("effector");
const ramda_1 = require("ramda");
const events_1 = require("./events");
const store_1 = require("./store");
const initModuleRegistry = () => {
    (0, effector_1.sample)({
        clock: events_1.setModuleStatus,
        source: store_1.$moduleRegistry,
        filter: (modules, { status, moduleName }) => { var _a; return Boolean(status !== 'failed' && ((_a = modules[moduleName]) === null || _a === void 0 ? void 0 : _a.error)); },
        fn: (modules, { moduleName }) => (0, ramda_1.dissocPath)([moduleName, 'error'], modules),
        target: store_1.$moduleRegistry
    });
};
exports.initModuleRegistry = initModuleRegistry;
